import React from 'react';
import { connect } from 'react-redux';
import Picker from 'react-month-picker';
import moment from 'moment';
import { getSchoolMonthlyFinanceAction } from 'actions/School/SchoolAction';
import PanelWrapper from 'components/UI/PanelWrapper/index';
import 'react-month-picker/css/month-picker.css';
import './monthly.scss'

const LANGUAGE = localStorage.getItem('language');
const MONTHS= ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
const mapStateToProps = (state) => ({
  monthlyFinance: state.schMonthlyFinance
})

const locale = {
  id: 'MonthlyFinance',
  code: 'CN',
  text: {
    'MMMM YYYY': 'YYYY年MM月',
    '': '',

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getMonthlyFinance: (schoolId, params) => dispatch(getSchoolMonthlyFinanceAction(schoolId, params))
  }
}

class MonthlyFinance extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      selectedYear: moment().subtract(1,'months').get('year'),
      selectedMonth: moment().subtract(1,'months').get('month')+1
    }

    this.onDateChanged = this.onDateChanged.bind(this);
    this.onDateClicked = this.onDateClicked.bind(this);
  }

  componentDidMount(){
    this.props.getMonthlyFinance(localStorage.getItem('schoolId'),{
      start_date:moment().subtract(1,'months').format("YYYY-MM-01"),
      end_date:moment().subtract(1,'months').endOf('month').format("YYYY-MM-DD"),
      paging_or_not:0,
      summary: 1
    })
  }
  onDateClicked(){
    this.refs.pickAMonth.show();
  }
  onDateChanged(year, month){

    let newMonth;
    let searchDate;
    if(month < 10){
      newMonth = `0${month}`
    }else {
      newMonth = month;
    }

    searchDate = `${year}-${newMonth}-01`

    this.setState({selectedYear: year, selectedMonth:month});
    this.props.getMonthlyFinance(localStorage.getItem('schoolId'),{
      start_date: moment(searchDate).format('YYYY-MM-DD'),
      end_date:moment(searchDate).endOf('month').format("YYYY-MM-DD"),
      paging_or_not:0,
      summary: 1
    })
    this.refs.pickAMonth.dismiss();
  }

  render(){
    const {selectedYear, selectedMonth} = this.state
    return(
      <PanelWrapper className='monthly' title={__('Monthly Summary', 'monthlyFinance')}>
        <div className="row">
          <div className='col-lg-19 col-md-9'>
            <h1>{moment(selectedYear+'-'+selectedMonth, 'YYYY-MM').format(__('MMMM YYYY', locale))}</h1>
          </div>
          <div className='col-lg-3 col-md-3' style={{marginTop:'32px', textAlign:'right', color:'#255FEE'}} >
            <div onClick={this.onDateClicked} style={{cursor:'pointer'}}>
              <i className="fa icon-calendar fa-lg" aria-hidden="true" />
              <span style={{marginLeft:'10px'}} >{__('Search by Date', 'monthlyFinance', null, true)}</span>
            </div>
            <div>
              <Picker
                  ref="pickAMonth"
                  years={{min: {year:2014, month:1}, max: {year: moment().subtract(1,'months').get('year'), month:moment().subtract(1,'months').get('month')+1}}}
                  value={{year: this.state.selectedYear, month: this.state.selectedMonth}}
                  lang={MONTHS}
                  theme="dark"
                  onChange={this.onDateChanged}
                  >
              </Picker>
            </div>
          </div>
        </div>
        <div className="row" style={{fontSize: '24px', marginTop:'64px'}}>
          <p className='col-lg-6 col-md-6' style={{textAlign:'left', color:'#9B9B9B'}}>{__('Monthly Income', 'monthlyFinance', null, true)}</p>
          <p className='col-lg-6 col-md-6' style={{textAlign:'right'}}>{(this.props.monthlyFinance.total_income>=0)? '+':'-'}{this.props.monthlyFinance.total_income} CAD</p>
        </div>
        <hr style={{borderColor:'#F2F2F2'}} />
        <div className="row" style={{fontSize: '24px', marginTop:'50px'}}>
          <p className='col-lg-6 col-md-6' style={{textAlign:'left', color:'#9B9B9B'}}>{__('Monthly Spending', 'monthlyFinance', null, true)}</p>
          <p className='col-lg-6 col-md-6' style={{textAlign:'right'}}>{(this.props.monthlyFinance.total_refund>=0)? '-':'+'}{this.props.monthlyFinance.total_refund} CAD</p>
        </div>
        <hr style={{borderColor:'#F2F2F2'}} />
        <div className="row" style={{fontSize: '24px', marginTop:'50px'}}>
          <p className='col-lg-6 col-md-6' style={{textAlign:'left', color:'#9B9B9B'}}>{__('Net Income', 'monthlyFinance', null, true)}</p>
          <p className='col-lg-6 col-md-6' style={{textAlign:'right', color:'#FCAF3D'}}>{(this.props.monthlyFinance.total_income-this.props.monthlyFinance.total_refund>=0)? '+':'-'}{this.props.monthlyFinance.total_income-this.props.monthlyFinance.total_refund} CAD</p>
        </div>
        <hr style={{borderColor:'#F2F2F2'}} />
      </PanelWrapper>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MonthlyFinance)



// WEBPACK FOOTER //
// ./src/containers/pages/MonthlyFinance/index.js